var map = {
	"./asia/bali/canggu/canggu-categories.json": 95906,
	"./asia/bali/ubud/ubud-categories.json": 94960,
	"./asia/china/beijing/beijing-categories.json": 89299,
	"./asia/china/shanghai/shanghai-categories.json": 4631,
	"./asia/country/city/city-categories.json": 62444,
	"./asia/indonesia/jakarta/jakarta-categories.json": 72072,
	"./asia/japan/kyoto/kyoto-categories.json": 10134,
	"./asia/japan/osaka/osaka-categories.json": 89958,
	"./asia/japan/tokyo/tokyo-categories.json": 89762,
	"./asia/korea/seoul/seoul-categories.json": 24256,
	"./asia/malaysia/borneo/borneo-categories.json": 99597,
	"./asia/malaysia/kualalumpur/kualalumpur-categories.json": 85317,
	"./asia/myanmar/bagan/bagan-categories.json": 67275,
	"./asia/myanmar/yangon/yangon-categories.json": 81633,
	"./asia/taiwan/taipei/taipei-categories.json": 59598,
	"./asia/thailand/bangkok/bangkok-categories.json": 19457,
	"./asia/thailand/chiangmai/chiangmai-categories.json": 88329,
	"./asia/thailand/kophangan/kophangan-categories.json": 59813,
	"./asia/thailand/kosamui/kosamui-categories.json": 82857,
	"./asia/thailand/phuket/phuket-categories.json": 87449,
	"./asia/vietnam/hanoi/hanoi-categories.json": 93538,
	"./asia/vietnam/hochiminhcity/hochiminhcity-categories.json": 52858,
	"./europe/country/city/city-categories.json": 32764,
	"./europe/croatia/zagreb/zagreb-categories.json": 59581,
	"./europe/france/paris/paris-categories.json": 11133,
	"./europe/germany/berlin/berlin-categories.json": 14639,
	"./europe/italy/rome/rome-categories.json": 52507,
	"./europe/italy/venice/venice-categories.json": 64965,
	"./europe/poland/krakow/krakow-categories.json": 26472,
	"./europe/poland/warsaw/warsaw-categories.json": 12904,
	"./europe/portugal/lisbon/lisbon-categories.json": 60318,
	"./europe/portugal/madeira/madeira-categories.json": 56002,
	"./europe/russia/city/city-categories.json": 3195,
	"./europe/spain/barcelona/barcelona-categories.json": 9069,
	"./europe/spain/madrid/madrid-categories.json": 63249,
	"./middleeast/country/city/city-categories.json": 63978,
	"./middleeast/israel/telaviv/telaviv-categories.json": 80050,
	"./middleeast/turkey/istanbul/istanbul-categories.json": 39386,
	"./middleeast/uae/dubai/dubai-categories.json": 56359,
	"./southamerica/argentina/buenosaires/buenosaires-categories.json": 37298,
	"./southamerica/brazil/riodejaneiro/riodejaneiro-categories.json": 87023,
	"./southamerica/colombia/bogota/bogota-categories.json": 13457,
	"./southamerica/colombia/cartagena/cartagena-categories.json": 83567,
	"./southamerica/colombia/medellin/medellin-categories.json": 82769,
	"./southamerica/country/city/city-categories.json": 99491,
	"./southamerica/mexico/mexicocity/mexicocity-categories.json": 61934,
	"./southamerica/mexico/playadelcarmen/playadelcarmen-categories.json": 67574,
	"./southamerica/mexico/tulum/tulum-categories.json": 52948,
	"./southamerica/peru/lima/lima-categories.json": 46479
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90367;